export const API_URL = window.__RUNTIME_CONFIG__.REACT_APP_API_URL
export const REACT_APP_BASE_URL_FORM = 'https://bpm-form-api.server247.info/api'
export const PDF_URL = window.__RUNTIME_CONFIG__.REACT_APP_BASE_URL
export const IMAGE_BASE_URL = window.__RUNTIME_CONFIG__.REACT_APP_BASE_URL

export const FRONT_END_BASE_URL = window.__RUNTIME_CONFIG__.REACT_FRONTEND_BASE_URL